import svgUrl from "ni:svgr;in29XLhvIKH1LBqanWBXqKESZUT3vwh8oya5OWIh5SU";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const LeftJoinMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><circle cx={16} cy={12} r={8} fill="var(--tbl--colors--icons--transformation--tertiary)" /><circle cx={8} cy={12} r={8} fill="var(--tbl--colors--icons--transformation--primary)" /><path fill="#fff" fillOpacity={0.2} fillRule="evenodd" d="M12 18.93A7.997 7.997 0 0 0 16 12a7.997 7.997 0 0 0-4-6.93A7.997 7.997 0 0 0 8 12a7.997 7.997 0 0 0 4 6.93Z" clipRule="evenodd" /></svg>;
const Memo = memo(LeftJoinMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "LeftJoinMIcon";
}